import React from "react";
import {Navigate} from "react-router-dom";

//Authentication
import Login from "../pages/Authentication/Login";
import ForgetPasswordPage from "../pages/Authentication/ForgetPassword";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import ResetPassword from "../pages/Authentication/ResetPassword";
import VerifyEmail from "../pages/Authentication/VerifyEmail";
import EmailVerified from "../pages/Authentication/EmailVerified";
import CreateShop from "../pages/Authentication/CreateShop";

import Order from "../pages/Order/index";
import OrderDetail from "../pages/Order/Detail";
import DraftOrderAddItem from "../pages/Order/Detail/AddItem";
import WebMenu from "../pages/Web/ShopMenu";
import RevenueReport from "../pages/Report/Revenue";
import OrderReport from "../pages/Report/Order";
import MenuReport from "../pages/Report/Menu";
import StaffReport from "../pages/Report/Staff";
import ChangePassword from "../pages/Settings/ChangePassword";
// import CheckInOut from "../pages/CheckInOut/index";
// import PersonalAttendance from "../pages/CheckInOut/PersonalAttendance";
// import PaymentMethod from "../pages/PaymentMethod/index";
import MenuList from "../pages/Menu";
import CreateMenu from "../pages/Menu/create";
import EditMenu from "../pages/Menu/edit";
import MenuCategory from "../pages/Menu/MenuCategory";
import MenuOptionsPage from "../pages/Menu/Options";
import MenuOptionValuesPage from "../pages/Menu/Options/Detail";
import MenuImport from "../pages/Menu/Import";
import NotificationPage from "../pages/Notification";
import NotificationsSettings from "../pages/Settings/Notifications";
import FeedbackPage from "../pages/Settings/Feedback";
import ContactPage from "../pages/Settings/Contact";
import ShopZones from "../pages/Shop/Zones";
import ZoneTables from "../pages/Shop/Tables";
import ShopQrCode from "../pages/Shop/QrCode";
import QrCodeCreate from "../pages/Shop/QrCodeCreate";
import ShopInfo from "../pages/Shop/Info";
import ShopEditInfo from "../pages/Shop/EditInfo";
import WifiPage from "../pages/Shop/Wifi";
import SubscriptionPage from "../pages/Subscription";
import SubscriptionDetailPage from "../pages/Subscription/Detail";
import SubscriptionCheckoutPage from "../pages/Subscription/Checkout";
import ShopMembers from "../pages/Shop/Members";
import QrCheck from "../pages/Shop/QrCheck";


const authProtectedRoutes = [

    {path: "/logout", component: <Logout/>},
    {path: "/verify-email", component: <VerifyEmail />, layout: "blank"},
    {path: "/create-shop", component: <CreateShop />, layout: "blank"},
    // Order
    {path: "/order", component: <Order/>},
    {path: "/order/:orderId", component: <OrderDetail/>},
    {path: "/order/:orderId/add-item", component: <DraftOrderAddItem />},
    // Menu
    {path: "/menu", component: <MenuList />},
    {path: "/menu/create", component: <CreateMenu />},
    {path: "/menu/:menuId/edit", component: <EditMenu />},
    {path: "/menu/categories", component: <MenuCategory />},
    {path: "/menu/options", component: <MenuOptionsPage />},
    {path: "/menu/options/:optionId", component: <MenuOptionValuesPage />},
    {path: "/menu/import", component: <MenuImport />},
    // Shop
    {path: "/shop/info", component: <ShopInfo />},
    {path: "/shop/info/edit", component: <ShopEditInfo />},
    {path: "/shop/wifi", component: <WifiPage />},
    {path: "/shop/zones", component: <ShopZones />},
    {path: "/shop/zones/:zoneId", component: <ZoneTables />},
    {path: "/shop/qr", component: <ShopQrCode />},
    {path: "/shop/qr/create", component: <QrCodeCreate />},
    {path: "/shop/qr/check", component: <QrCheck />},
    {path: "/shop/members", component: <ShopMembers />},
    {path: "/subscription", component: <SubscriptionPage />},
    {path: "/subscription/:planId", component: <SubscriptionDetailPage />},
    {path: "/subscription/checkout/:paymentTransactionId", component: <SubscriptionCheckoutPage />},
    // Report
    {path: "/report/revenue", component: <RevenueReport/>},
    {path: "/report/order", component: <OrderReport/>},
    {path: "/report/menu", component: <MenuReport/>},
    {path: "/report/staff", component: <StaffReport/>},
    // Check In Out (ẩn route theo yêu cầu)
    // {path: "/check-in-out", component: <CheckInOut/>},
    // {path: "/my-attendance", component: <PersonalAttendance/>},
    // payment (ẩn route theo yêu cầu)
    // {path: "/payment-method", component: <PaymentMethod/>},
    // Notifications
    {path: "/notifications", component: <NotificationPage />},
    {path: "/settings/notifications", component: <NotificationsSettings />},
    {path: "/settings/change-password", component: <ChangePassword />},
    {path: "/settings/feedback", component: <FeedbackPage />},
    {path: "/contact", component: <ContactPage />},

    {path: "*", component: <Navigate to="/order"/>},
];

const publicRoutes = [
    // Authentication Page
    { path: "/login", component: <Login /> },
    { path: "/email-verified", component: <EmailVerified /> },
    { path: "/register", component: <Register/>},
    { path: "/forgot-password", component: <ForgetPasswordPage/>},
    { path: "/password-reset/:token", component: <ResetPassword/>},
    { path: "/web-menu/:qrToken", component: <WebMenu /> },
    {
        path: "/",
        component: <Navigate to="/order" />,
    },
];

export {authProtectedRoutes, publicRoutes};
